import React, { useLayoutEffect, useRef } from "react";
import { NavLink } from "react-router-dom";

import { useAuth } from "../context/AuthContext";
import "../App.css";

// Each page mounts its own <Sidebar />, so navigating to a new page creates
// a brand-new sidebar DOM element that starts scrolled to the top — even if
// the admin had scrolled down to click something near the bottom. Persist
// the scroll position across that remount via sessionStorage (not React
// state, since state wouldn't survive the remount either).
const SCROLL_KEY = "sidebarScrollTop";

function navLinkClass({ isActive }) {
  return isActive ? "sidebar-link-active" : undefined;
}

function Sidebar() {

  const { role: backendRole } = useAuth();
  const normalizedRole = backendRole?.toLowerCase();
  const scrollRef = useRef(null);

  const role =
    normalizedRole === "admin" ? "Admin" :
    normalizedRole === "customer" ? "Customer" :
    normalizedRole === "staff" || normalizedRole === "supervisor" ? "Supervisor" :
    null;

  useLayoutEffect(() => {
    const el = scrollRef.current;
    if (!el) return;
    const saved = sessionStorage.getItem(SCROLL_KEY);
    if (saved) el.scrollTop = Number(saved);

    const handleScroll = () => sessionStorage.setItem(SCROLL_KEY, String(el.scrollTop));
    el.addEventListener("scroll", handleScroll);
    return () => el.removeEventListener("scroll", handleScroll);
  }, []);

  return (

    <div className="sidebar" ref={scrollRef}>

      <div className="sidebar-logo">

      </div>

      {role === "Admin" && (
        <>

          <div className="menu-section">

        <NavLink to="/admin" end className="sidebar-logo">
          🌿 Admin Dashboard
        </NavLink>

            <NavLink to="/admin" end className={navLinkClass}>
              Dashboard
            </NavLink>

            <NavLink to="/plots" className={navLinkClass}>
              Plots
            </NavLink>

            <NavLink to="/customers" className={navLinkClass}>
              Customers
            </NavLink>

            <NavLink to="/registration-requests" className={navLinkClass}>
              Registrations
            </NavLink>

          </div>

          <div className="menu-section">

            <p className="menu-title">
              OPERATIONS
            </p>

            <NavLink to="/maintenance" className={navLinkClass}>
              Maintenance
            </NavLink>

            {/* Water / Bore hidden per request — re-enable by uncommenting;
                the /water-charges route itself is untouched.
            <NavLink to="/water-charges" className={navLinkClass}>
              Water / Bore
            </NavLink>
            */}

            <NavLink to="/issues" className={navLinkClass}>
              Issues
            </NavLink>

            <NavLink to="/service-tickets" className={navLinkClass}>
              Service Requests
            </NavLink>

          </div>

          <div className="menu-section">

            <p className="menu-title">
              CUSTOMER
            </p>

            {/* Documents hidden per request — re-enable by uncommenting;
                the /documents route itself is untouched.
            <NavLink to="/documents" className={navLinkClass}>
              Documents
            </NavLink>
            */}

            <NavLink to="/visits" className={navLinkClass}>
              Visits
            </NavLink>

            <NavLink to="/messaging" className={navLinkClass}>
              Messaging
            </NavLink>

            <NavLink to="/estate-updates" className={navLinkClass}>
              Updates
            </NavLink>

            {/* Updates Feed hidden per request — re-enable by uncommenting;
                the /customer-updates route itself is untouched.
            <NavLink to="/customer-updates" className={navLinkClass}>
              Updates Feed
            </NavLink>
            */}

          </div>

          <div className="menu-section">

            <p className="menu-title">
              ADMIN
            </p>

            <NavLink to="/reports" className={navLinkClass}>
              Reports
            </NavLink>

            <NavLink to="/staff" className={navLinkClass}>
              Staff
            </NavLink>

            <NavLink to="/zones" className={navLinkClass}>
              Zones
            </NavLink>

            <NavLink to="/projects" className={navLinkClass}>
              Projects
            </NavLink>

            <NavLink to="/payments" className={navLinkClass}>
              Payments
            </NavLink>

            <NavLink to="/invoices" className={navLinkClass}>
              Invoices
            </NavLink>

            <NavLink to="/quotations" className={navLinkClass}>
              Estimates
            </NavLink>

            <NavLink to="/admin-referrals" className={navLinkClass}>
              Referrals
            </NavLink>

            <NavLink to="/referral-statuses" className={navLinkClass}>
              Referral Master
            </NavLink>

            <NavLink to="/zoho-integration" className={navLinkClass}>
              Zoho Integration
            </NavLink>

            <NavLink to="/due-plots" className={navLinkClass}>
              Due Plots
            </NavLink>

          </div>

        </>
      )}

      {role === "Supervisor" && (

        <div className="menu-section">
        <NavLink to="/supervisor-dashboard" end className="sidebar-logo">
          🌿 Supervisor Portal
        </NavLink>

          <NavLink to="/supervisor-dashboard" end className={navLinkClass}>
            Dashboard
          </NavLink>

          <NavLink to="/assigned-plots" className={navLinkClass}>
            Assigned Plots
          </NavLink>

          <NavLink to="/supervisor-visits" className={navLinkClass}>
            Visits
          </NavLink>

          <NavLink to="/upload-photos" className={navLinkClass}>
            Upload Photos
          </NavLink>

          <NavLink to="/maintenance-tasks" className={navLinkClass}>
            Maintenance Tasks
          </NavLink>

          <NavLink to="/maintenance" className={navLinkClass}>
            Maintenance Report
          </NavLink>

        </div>

         )}

{role === "Customer" && (

  <div className="menu-section">

<NavLink to="/my-farm" end className="sidebar-logo">
  🌿 Customer Portal
</NavLink>


    <NavLink to="/my-farm" end className={navLinkClass}>
      My Farm
    </NavLink>

    {/* Documents hidden for the first launch — re-enable post-launch by
        uncommenting; the /documents route itself is untouched.
    <NavLink to="/documents" className={navLinkClass}>
      Documents
    </NavLink>
    */}

    <NavLink to="/billing" className={navLinkClass}>
      Billing
    </NavLink>

    {/* Service Request hidden for the first launch — re-enable post-launch
        by uncommenting; the /customer-service-tickets route itself is
        untouched.
    <NavLink to="/customer-service-tickets" className={navLinkClass}>
      Service Request
    </NavLink>
    */}

    <NavLink to="/customervisits" className={navLinkClass}>
      Book a Visit
    </NavLink>

    <NavLink to="/messages" className={navLinkClass}>
      Messages
    </NavLink>

    <NavLink to="/referral" className={navLinkClass}>
      Referral
    </NavLink>

    {/* NOC hidden for the first launch — re-enable post-launch by
        uncommenting; the /customer-noc route itself is untouched.
    <NavLink to="/customer-noc" className={navLinkClass}>
      NOC
    </NavLink>
    */}

    <NavLink to="/customer-profile" className={navLinkClass}>
      Profile
    </NavLink>
    <NavLink to="/customer-updates" className={navLinkClass}>
      Updates
    </NavLink>

    <NavLink to="/contact" className={navLinkClass}>
      Contact
    </NavLink>

    <NavLink to="/about" className={navLinkClass}>
      About JF
    </NavLink>

  </div>

)}



    </div>

  );

}

export default Sidebar;
